import Aos from "aos";
import React, { useEffect, useState } from "react";
import img from "../../assets/img/trucksside.jpg";
import { Link } from "react-router-dom";
import Button from "../Button";
import "./index.scss";
import Footer from "../footer/Footer";
import about1 from "../../assets/img/office.jpeg";
import about2 from "../../assets/img/20230817_113325.jpg";
import about3 from "../../assets/img/offices.jpeg";

const Contacts = () => {
  const [readMore, setReadMore] = useState(false); //set readMore to be false by default

  //collapse the content

  let readMore1 = `
    The Kgagamela Holdings offers comprehensive, value-added services to create an environment that minimizes risk and maximizes returns for our customers - allowing projects to be delivered on time and on budget, with no surprises. Our collaborative project approach sets the standard for communication with our customers to provide client-driven solutions and satisfaction.

    We pride ourselves on being very flexible and reacting quickly to customer needs as well as market demands. We are a service organization whose mission is to provide efficient solutions to our customers’ challenges.
`;
  useEffect(() => {
    Aos.init({ duration: 1500 });

    let el1 = document.getElementById("header-bar");

    el1.classList.remove("in-viewport");
    el1.classList.add("out-viewport");
    el1.classList.remove("animate__fadeInDown");

    el1.classList.add("animate__fadeInDown");
    // el4.style.display = "none";
  }, []);

  let scrool = () => {
    let url = window.location.href;
    url = url.split("#");
    url = url[0] + "#Contact";
    window.location.href = url;
  };

  const about = [
    {
      name: `Since 2004, our customers have come to know and trust the Kgagamela Holdings Standard for Construction. Our core values of integrity, reliability and innovation are integral to delivering a superior customer experience. We provide economical and efficient solution to our client’s challenges. We take ownership of
             the issues and understand our responsibility and commitment to our clients.`,
      url: about1,
      title: "Our Values",
    },
    {
      name: `Kgagamela Holdings is a full-service construction management and general 
            contracting firm that operate mainly in the Limpopo. We are a vertically integrated organization, composed of a variety of business units organized around industry sectors. The business units are very diverse and each unit specializes in its own core industry. This structure allows each division to operate and develop expertise based on the demands of its specific industry. It also provides stability 
            for the company as market forces vary within different market sectors.`,
      url: about2,
      title: "Core Services",
    },
    {
      name: `The Kgagamela Holdings offers comprehensive, value-added services to create an
             environment that minimizes risk and maximizes returns for our customers - allowing
              projects to be delivered on time and on budget, with no surprises. Our collaborative 
              project approach sets the standard for 
            communication with our customers to provide client-driven solutions and satisfaction.`,
      url: about3,
      title: "Why Choose Us",
    },
  ];

  return (
    <>
      <div id="Contact" className="py-4 mt-4">
        <div className="container mt-4">
          <h2 className="text-center fw-bold pt-4 text-uppercase mb-4">
            Contact Us
          </h2>
          <div className="border p-3">
            <div className="row">
              <div className="col-lg-6">
                <div
                  className="item border p-3 text-center mb-4 m-lg-0"
                  data-aos="fade-down"
                >
                  <h6>Find US</h6>
                  <hr style={{ borderWidth: 2 }} />
                  <div className="contact-location">
                    <p className="m-0">R37 Road Riba-Cross</p>
                    <p className="m-0">Driekop</p>
                    <p className="m-0">Burgersfort</p>
                    <p className="m-0">South Africa</p>
                    <p className="m-0">1150</p>
                    <hr />
                    <span className="bg-secondary rounded px-3 py-1 text-white ">
                      {" "}
                      Admin Hours{" "}
                    </span>
                    <p className="m-0">
                      {" "}
                      Operating Hours: 08:15 - 16:30 Mon-Fri
                    </p>
                    <span className="bg-secondary rounded px-3 py-1 text-white ">
                      {" "}
                      Operation Hours{" "}
                    </span>
                    <p className="m-0"> Operating Hours: 24 Hours</p>
                    <hr />
                  </div>
                  <ul className="list-unstyled findus-info mt-3">
                    <li>
                      <i className="fa-solid fa-envelope"></i>
                      <a href="mailto:info@medsmadiagane.co.za">
                        info@kgagamelaholdings.co.za
                      </a>
                    </li>
                    <li className="text-left my-1">
                      <span className="bg-secondary rounded px-3 py-1 text-white ">
                        {" "}
                        Operations Contacts{" "}
                      </span>
                      <br />
                      <i className="fa-solid fa-phone"></i>
                      <a href="tel:+27797168637" className="text-small">
                        <small>+27 797 168 637</small>
                      </a>{" "}
                      /
                      <a href="tel:+27786400907">
                        <small>+27 786 400 907 </small>
                      </a>
                    </li>
                    <li className="text-left my-1">
                      <span className="bg-secondary rounded px-3 py-1 text-white ">
                        {" "}
                        Admin Contacts{" "}
                      </span>
                      <br />
                      <i className="fa-solid fa-phone"></i>
                      <a href="tel:+27786459391" className="text-small">
                        <small>+27 78 645 9391</small>
                      </a>
                    </li>
                    <li className="my-2 text-left"></li>
                  </ul>
                  <ul className="list-unstyled contact-socials d-flex justify-content-center mt-4">
                    <li className="facebook">
                      <a href="facebook">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    </li>
                    <li className="whatsapp">
                      <a href="whatsapp://send?text=Hi!&amp;phone=+27678844843">
                        <i className="fa-brands fa-whatsapp"></i>
                      </a>
                    </li>
                    <li className="twitter">
                      <a href="twitter">
                        <i className="fa-brands fa-twitter"></i>
                      </a>
                    </li>
                    <li className="instagram">
                      <a href="instagram">
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6">
                <form
                  action=""
                  className="border p-3  contact-form"
                  data-aos="fade-up"
                >
                  <div className="row ">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name:"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <input
                          type="number"
                          className="form-control"
                          id="phone"
                          placeholder="Phone:"
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <input
                          type="email"
                          className="form-control"
                          id="EmailAddress"
                          placeholder="Email Address:"
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Message"
                          id="floatingTextarea2"
                          style={{ height: 200 }}
                          defaultValue={""}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn mt-3">
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="mt-5 p-3 border">
              <iframe
                data-aos="zoom-in"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3627.018003437268!2d30.188219675675885!3d-24.623064378085008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDM3JzIzLjAiUyAzMMKwMTEnMjYuOSJF!5e0!3m2!1sen!2sza!4v1692096723444!5m2!1sen!2sza"
                width={"100%"}
                height={450}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contacts;
